export const DEFAULT_VALIDATION_MESSAGES = {
  CURRENCY: 'A currency is required',
  CUSTOMER_ID: 'A customer is required',
  TITLE: 'A quote title is required',
  DEAL_TYPE: 'A deal type is required',
  EXPIRY: 'An expiry date is required',
  QUOTE_NUMBER: 'A quote number is required',
  START_DATE: 'A start date is required',
  START_DATE_AUTO_EXECUTE: 'A start date is required',
  AMENDMENT_CONTRACT_DURATION:
    'The contract duration must match the schedule being amended',
  AMENDMENT_DATE_PASSED: 'Amendment start date cannot be in the past'
}
